import { createContext, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

//Componnets
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import CustomModal from "../../../../app/common-components/CustomModal";
import CustomOffCanvas from "../../../../app/common-components/CustomOffCanvas";
import DiscardChanges from "../../../../app/common-components/DiscardChanges";
import EmptyDrillDownOffCanvas from "../../../../app/common-components/DrillDown/EmptyDrillDownOffCanvas";
import Spinners from "../../../../app/common-components/Spinner";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData";
import Input from "../../../../app/common-components/form/input";
import { hideOffCanvas, setIsOffCanvasOpen } from "../../../../app/commonSlice";
import { convertEpochToDate, useCommonAlert } from "../../../../app/utilities/helpers";
import { useTimeout, useIsMounted } from "../../../../app/utilities/reactHooks";

// Internal Comp
import CloudAccountsDrillDown from "../cmdb-overview/CloudAccountsDrillDown";

// Slice
import { configurationApi } from "../../../../app/services/configurationApi";
import { cloudAccountListApi, cloudAccountTestConnection } from "../cmdb-overview/CMDBSlice";

// 3rd Party Libraries
import _, { get, isEmpty } from "lodash";
import { Col, Row } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

// Styles
import "../styles.scss";


export const ProjectContext = createContext();

const Cloudaccount = () => {
  const dispatch = useDispatch();
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const timeout = useTimeout();
  const isMountedRef = useIsMounted();
  const { userRole } = useSelector(
    (state) => state.common.loggedUser
  );
  const notAllowedRoles = ["Application Manager", "Department Head", "Division Head"];
  const userAccess = !userRole.some(role => notAllowedRoles.includes(role));
  const { cloudAccountListData, cloudAccountCountData, cloudAccountCountLoading, cloudAccountListLoading } = useSelector((state) => state.cmdbId);
  const accountCheck = cloudAccountListData ? cloudAccountListData?.data?.map((account) => account.accountId) : [];
  const [pageNo, setpageNo] = useState(0);
  const [pageLimit, setpageLimit] = useState(10);
  const [searchKey, setsearchKey] = useState("");
  const TableContent = cloudAccountListData?.data ? cloudAccountListData?.data : [];
  const totalElements = cloudAccountListData?.totalCount ? cloudAccountListData?.totalCount : "";
  const calculatedPageCount = totalElements ? Math.ceil(totalElements / pageLimit) : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;
  const [currentAction, setCurrentAction] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showServerForm, setShowServerForm] = useState(false);
  const { efficiency } = useSelector((state) => state);
  const [showAccessKey, setShowAccessKey] = useState("");
  const [showAssumeKey, setShowAssumeKey] = useState("");
  const [accountId, setAccountId] = useState("");
  const [showAccountType, setShowAccountType] = useState("");
  const [showConfic, setConfic] = useState(false);
  const [showSecretKey, setShowSecretKey] = useState("");
  const [showAccountName, setShowAccountName] = useState("");
  const [showCsp, setShowCsp] = useState("");
  const [getId, setGetId] = useState("");
  const [cSperrorMessage, setCSperrorMessage] = useState("");
  const [showCSPError, setShowCSPError] = useState("");
  const [AccerrorMessage, setAccerrorMessage] = useState("");
  const [showAccError, setShowAccError] = useState("");
  const [AkeyerrorMessage, setAkeyerrorMessage] = useState("");
  const [assumekeyerrorMessage, setAssumekeyerrorMessage] = useState("");
  const [showAkeyError, setShowAkeyError] = useState("");
  const [showAssumekeyError, setShowAssumekeyError] = useState("");
  const [secretKeyerrorMessage, setSecretKeyerrorMessage] = useState("");
  const [showsecretkeyError, setShowsecretkeyError] = useState("");
  const [showtypeError, setShowstypeError] = useState("");
  const [typeErrorMessage, setTypeErrorMessage] = useState("");
  const [testLoader, setTestLoader] = useState(false);
  const [ddLoader, setDDLoader] = useState(false);
  const [cloudDeleteLoading, setCloudDeleteLoading] = useState(false);
  const [Serverstate, setServerstate] = useState({
    applicationConfig: false,
    appConfigTitle: "",
    cmdbId: "",
    serverList: {},
    BusnissTableListData: {},
  });
  const serverListData = get(efficiency, "appConfig.cloudTableData", []);
  const [state, setState] = useState({
    limit: 10,
    page: 0,
    count: 0,
    totalPages: 1,
    importModal: false,
    newApplication: false,
    projectId: "",
    file: "",
    fileInfo: "",
    fileError: "",
    deleteModalOpen: false,
    modalBodyTrigger: false,
    loadPage: false,
    loading: false,
    modalOpen: false,
    deleteId: "",
    id: "",
    cmdbId: "",
    appList: [],
    cloudTableData: [],
    cloudTrigger: [],
    tableReload: false,
    selectedOption: "AssumeRole",
    cspinputState: false,
    accIdinputState: false,
    accessKeyState: false,
    assumeKeyState: false,
    awsinputState: false,
    setImportOpen: false,
    addBodyAccount: false,
    conformationPop: false,
    selectedType: ''
  });
  const cloudAccountTable = state.cloudTableData;
  const payloadid = state?.id;
  const navigate = useNavigate();
  const [getCloudList] = configurationApi.useGetCloudListMutation();
  const [getCloudAccountSave] =
    configurationApi.useGetCloudAccountSaveMutation();
  const [getCloudDelete] = configurationApi.useGetCloudDeleteMutation();
  const [getCloudTrigger] = configurationApi.useGetCloudTriggerMutation();
  const [selectedOption, setSelectedOption] = useState("AssumeRole");

  let CloudAccountData = "";

  CloudAccountData = cloudAccountTable.data?.map((Cloud) => ({
    accountCreated: Cloud.accountCreated,
    accountId: Cloud.accountId,
    csp: Cloud.csp,
    type: Cloud.type,
    userCount: Cloud.userCount,
  }));

  const openDrillDown = async ({ title }, selectedLabels, accountId) => {
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        dropDownMenuOptions: false,
        title: "User Details",
        // noScroll:true,
        customClass: "mxh-90vh",
        selectedData: (
          <CloudAccountsDrillDown
            title={title}
            rowId={state.id}
            accountId={accountId}
          />
        ),
      })
    );
    try {
      console.error("Error occurred while fetching data: ");
    } catch (error) {
      console.error("Error occurred while fetching data: ", error);
    }
  };
  const payload = {
    "keyword": searchKey
  };
  useEffect(() => {
    // if(state.tableReload){
    getCloudList(setState((state) => ({
      ...state,
      loading: true,
    })))
      .unwrap()
      .then((data) => {
        setState((state) => ({
          ...state,
          loading: false,
          cloudTableData: data,
          count: data.length,
        }));
      });
    // }
  }, []);

  const fetchData = async (pageNo = pageNo, pageLimit = pageLimit, payload = payload) => {
    dispatch(cloudAccountListApi({ pageNumber: pageNo, itemsPerPage: pageLimit, payload }));
  };
  useEffect(() => {
    const payload = getPayload();
    fetchData(pageNo, pageLimit, payload);
  }, []);
  const handleTrigger = () => {
    getCloudTrigger()
      .unwrap(setState((state) => ({
        ...state,
        loading: true,
      })))
      .then((data) => {
        setState((state) => ({
          ...state,
          loading: false,
          cloudTrigger: data,
        }));
        showAlert("Trigger Process Completed Successfully", "success");
        const payload = getPayload(searchKey);
        fetchData(pageNo, pageLimit, payload);
      })
      .catch((error) => {
        showAlert("Failed to trigger!", "error");
      });
  };

  const showAlert = (message, type) => {
    callCommonAlert(type, message);
    setState((state) => ({
      ...state,
      tableReload: true,
      modalBodyTrigger: false,
    }));
    hideCommonAlert();
    setTimeout(() => {
      setState((state) => ({
        ...state,
        tableReload: false,
      }));
    }, 3000);
  };

  const getPayload = (key) => {
    const tablePayload = {
      keyword: key ? key : ''
    };
    return tablePayload;
  };

  const columns = [
    {
      Header: "Cloud Service Provider",
      accessor: "csp",
      disableSortBy: true,
    },

    {
      Header: "Account ID",
      tdClassName: "text-center",
      thClassName: "text-center",
      accessor: "accountId",
      disableSortBy: true,
    },
    {
      Header: "Account Name",
      accessor: "accountName",
      disableSortBy: true,
      Cell: ({ row, value }) => {
        if (Array.isArray(value)) {
          return <>{value.length !== 0 ? value.join(", ") : "-"}</>;
        } else {
          return <>{value ? value : "-"}</>;
        }
      }
    },
    {
      Header: "Application Name",
      accessor: "applicationName",
      disableSortBy: true,
      Cell: ({ row, value }) => {
        if (Array.isArray(value)) {
          return <>{value.length !== 0 ? value.join(", ") : "-"}</>;
        } else {
          return <>{value ? value : "-"}</>;
        }
      }
    },
    {
      Header: "Environment",
      accessor: "environment",
      tdClassName: "text-center",
      disableSortBy: true,
      Cell: ({ value }) => {
        if (Array.isArray(value)) {
          return <>{value.length !== 0 ? value.join(", ") : "-"}</>;
        } else {
          return <>{value ? value : "-"}</>;
        }
      },
    },
    {
      Header: "Account Created Date",
      accessor: "accountCreatedDate",
      tdClassName: "webKitCenter",
      thClassName: "text-center",
      disableSortBy: true,
      Cell: ({ value }) => {
        return <>{value ? (value !== 0 ? convertEpochToDate(value) : '-') : '-'}</>;
      },
    },
    {
      Header: "Last Imported On",
      colSpan: 3,
      thClassName: "text-center noSort",
      disableSortBy: true,
      columns: [
        {
          Header: "Security Hub Findings",
          accessor: "lastScannedDateForSecurityHub",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? (value !== 0 ? convertEpochToDate(value) : '-') : '-'}</>;
          },
        },
        {
          Header: "Cloud Cost Insights",
          accessor: "lastScannedDateForBillingCost",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? (value !== 0 ? convertEpochToDate(value) : '-') : '-'}</>;
          },
        },
        {
          Header: "TRMG",
          accessor: "lastScannedDateForTRMGCompliance",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? (value !== 0 ? convertEpochToDate(value) : '-') : '-'}</>;
          },
        },
        {
          Header: "Circular 09",
          accessor: "lastScannedDateForCircular09Compliance",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? (value !== 0 ? convertEpochToDate(value) : '-') : '-'}</>;
          },
        },
         {
          Header: "RMiT",
          accessor: "lastScanDateOfRMITCompliance",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? (value !== 0 ? convertEpochToDate(value) : '-') : '-'}</>;
          },
        },
         {
          Header: "Access Governance",
          accessor: "lastScanDateOfAccessReview",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? (value !== 0 ? convertEpochToDate(value) : '-') : '-'}</>;
          },
        },
         {
          Header: "Architecture Compliance",
          accessor: "lastScanDateOfArchitectureCompliance",
          tdClassName: "webKitCenter",
          thClassName: "text-center",
          disableSortBy: true,
          Cell: ({ value }) => {
            return <>{value ? (value !== 0 ? convertEpochToDate(value) : '-') : '-'}</>;
          },
        },
      ],
    },
    {
      Header: "Action",
      accessor: "Action",
      className: "text-center",
      thClassName: "text-center",
      tdClassName: "text-center",
      disableSortBy: true,
      Cell: ({ row }) => {
        return (
          <div className="actionsBtn d-flex justify-content-center">
            <div className="actcol p-0">
            <FiTrash2
                title="Delete"
                data-testid ={"deleteIcon"}
                className="iconStyleActions"
                   onClick={() => {
                  if (userAccess) {
                    setState((state) => ({
                      ...state,
                      modalOpen: true,
                      deleteId: row.original.accountId,
                    }));
                  }
                }}
              />
            </div>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    state.alert && hideAlert();
  }, [state.alert]);

const handleOptionChange = (e) => {
  const newOption = e.target.value;
  setSelectedOption(newOption);
  
  // Clear all validation errors and input states
  setShowCSPError(false);
  setShowAccError(false);
  setShowAkeyError(false);
  setShowAssumekeyError(false);
  setShowsecretkeyError(false);
  
  // Clear input fields
  setShowAccessKey("");
  setShowAssumeKey("");
  setShowSecretKey("");
  
  // Reset input states
  setState(prev => ({
    ...prev,
    cspinputState: false,
    accIdinputState: false,
    accessKeyState: false,
    assumeKeyState: false,
    conformationPop: true
  }));
};

  const openserver = async (action, accountId) => {
    if (action === "edit") {
      const filteredCloud = cloudAccountListData.filter(
        (Cloud) => Cloud.accountId === accountId
      );
      setShowCsp(filteredCloud.map((data) => data.csp).join(","));
      setAccountId(filteredCloud.map((data) => data.accountId).join(","));
      setShowSecretKey(
        filteredCloud
          .map((data) =>
            data.showSecretKey ? data.showSecretKey : "**********"
          )
          .join(",")
      );
      setShowAccessKey(
        filteredCloud
          .map((data) =>
            data.showAccessKey ? data.showAccessKey : "**********"
          )
          .join(",")
      );
      setShowAccountType(filteredCloud.map((data) => data.type).join(","));
      setSelectedOption(filteredCloud.map((data) => data.type).join(","));
      setGetId(filteredCloud.map((data) => data.id).join(","));
      setIsSidebarOpen(true);
      setCurrentAction("edit");
      setShowsecretkeyError("");
      setShowAkeyError("");
      setShowAssumekeyError("");
      setShowAccError("");
      setShowCSPError("");
      setShowstypeError("");
    } else {
      setShowCsp("");
      setAccountId("");
      setShowAccountType("");
      setShowSecretKey("");
      setShowAccessKey("");
      setSelectedOption("AssumeRole");
      setShowsecretkeyError("");
      setShowAkeyError("");
      setShowAssumekeyError("");
      setShowAccError("");
      setShowCSPError("");
      setShowstypeError("");
      setCurrentAction("add");
    }
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
    // setShowServerForm(true);
    // setShowServerAddBtn(false);
  };

  const handleSaveEdit = () => {
    const payload = {
      accessKey: showAccessKey,
      accountType: selectedOption,
      secretKey: showSecretKey,
      accountId: [accountId],
    };
    const toolValid = validation();
    if (!toolValid) {
      try {
        setDDLoader(true);
        getCloudAccountSave(payload).then((data) => {

          if (data.data.statusCodeValue === 200) {
            callCommonAlert("success", _.get(data, "data.body") ? data.data.body : "Cloud Account Config Updated Successfully");
            setState((state) => ({
              ...state,
              modalOpen: false,
              tableReload: true,
            }));
            fetchData(pageNo, pageLimit, getPayload(searchKey));
            addserverclose();
            hideCommonAlert();
            setTimeout(() => {
              setState((state) => ({
                ...state,
                tableReload: false,
              }));
            }, 2000);
            setDDLoader(false);
          } else if (data.data.statusCodeValue === 400) {
            // addserverclose();
            callCommonAlert("error", _.get(data, "data.body") ? data.data.body : "Account already exist");
            setState((state) => ({
              ...state,
              modalOpen: false,
              tableReload: true,
            }));
            setTimeout(() => {
              setState((state) => ({
                ...state,
                tableReload: false,
              }));
            }, 2000);
            hideCommonAlert();
            setDDLoader(false);
          }
        });
      } catch (error) {
        callCommonAlert("error", "Something went wrong. Please try again");
        setState((state) => ({
          ...state,
          modalOpen: false,
          tableReload: true,
        }));
        hideCommonAlert();
        setTimeout(() => {
          setState((state) => ({
            ...state,
            tableReload: false,
          }));
        }, 2000);
        setDDLoader(false);
      }
    }
  }; 
const validation = () => {
  let validation = false;
  
  // Clear all previous errors
  setShowCSPError(false);
  setShowAccError(false);
  setShowAkeyError(false);
  setShowAssumekeyError(false);
  setShowsecretkeyError(false);
  
  // Validate CSP
  if (showCsp.trim() === '') {
    setCSperrorMessage('Cloud Service Provider should not be empty');
    setShowCSPError(true);
    setState(prev => ({ ...prev, cspinputState: true }));
    validation = true;
  }
  
  // Validate Account ID
  if (accountId.trim() === '') {
    setAccerrorMessage('Account ID should not be empty');
    setShowAccError(true);
    setState(prev => ({ ...prev, accIdinputState: true }));
    validation = true;
  } else if (accountCheck.includes(accountId) && showConfic === false) {
    setAccerrorMessage('Account ID already exists');
    setShowAccError(true);
    setState(prev => ( { ...prev, accIdinputState: true }));
    validation = true;
  } else if (accountId.length < 12) {
    setAccerrorMessage('Account ID is invalid');
    setShowAccError(true);
    setState(prev => ({ ...prev, accIdinputState: true }));
    validation = true;
  }

  // Validate fields based on selected option
  if (selectedOption === "AssumeRole") {
    if (showAssumeKey.trim() === '') {
      setAssumekeyerrorMessage('Assume Role should not be empty');
      setShowAssumekeyError(true);
      setState(prev => ({ ...prev, assumeKeyState: true }));
      validation = true;
    }
  } else { // AccessCredentials
    if (showAccessKey.trim() === '') {
      setAkeyerrorMessage('Access Key should not be empty');
      setShowAkeyError(true);
      setState(prev => ({ ...prev, accessKeyState: true }));
      validation = true;
    }
    if (showSecretKey.trim() === '') {
      setSecretKeyerrorMessage('Secret Key should not be empty');
      setShowsecretkeyError(true);
      setState(prev => ({ ...prev, accessKeyState: true }));
      validation = true;
    }
  }

  return validation;
};
  const handleSaveAdd = () => {
    const toolValid = validation();
    if (!toolValid) {

   let payload;
    
    if (selectedOption === "AssumeRole") {
      payload = {
        accessKey: "", // Empty for AssumeRole
        cloudProvider: showCsp,
        secretKey: "", // Empty for AssumeRole
        accountId: [accountId],
        assumeRole: showAssumeKey,
        roleOrStaticCred: true
      };
    } else { // AccessCredentials
      payload = {
        accessKey: showAccessKey,
        cloudProvider: showCsp,
        secretKey: showSecretKey,
        accountId: [accountId],
        assumeRole: "", // Empty for AccessCredentials
        roleOrStaticCred: false
      };
    }
      try {
        setDDLoader(true);
        getCloudAccountSave(payload).then((data) => {
          if (data.data.statusCodeValue === 200) {
            addserverclose();
            callCommonAlert("success", _.get(data, "data.body") ? data.data.body : "Cloud Account Config Added Successfully");
            setState((state) => ({
              ...state,
              modalOpen: false,
              tableReload: true,
            }));
            dispatch(
              setIsOffCanvasOpen({
                isDrilldownOpen: false,
                isDropDownhide: false,
              })
            );
            fetchData(pageNo, pageLimit, getPayload(searchKey));
            hideCommonAlert();
            setTimeout(() => {
              setState((state) => ({
                ...state,
                tableReload: false,
              }));
            }, 2000);
            setDDLoader(false);
          } else if (data.data.statusCodeValue === 400) {
            // addserverclose();
            callCommonAlert("error", _.get(data, "data.body") ? data.data.body : "Account already exist");
            setState((state) => ({
              ...state,
              modalOpen: false,
              tableReload: true,
            }));
            hideCommonAlert();
            setTimeout(() => {
              setState((state) => ({
                ...state,
                tableReload: false,
              }));
            }, 2000);
            setDDLoader(false);
          }
        });
      } catch (error) {
        // console.error(error);
        callCommonAlert("error", "Something went wrong. Please try again.");
        setState((state) => ({
          ...state,
          modalOpen: true,
          tableReload: true,
        }));
        hideCommonAlert();
        setTimeout(() => {
          setState((state) => ({
            ...state,
            tableReload: false,
          }));
        }, 2000);
        setDDLoader(false);
      }
    }
  };

  const handleCSP = (e) => {
    setShowCsp(e.target.value);
    setShowCSPError(false);
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
  };
  const handleACC = (e) => {
    let enteredValue = e.target.value;
    enteredValue = enteredValue.replace(/[^0-9]/g, '');
    setShowAccError(false);
    if (enteredValue.length > 12) {
      enteredValue = enteredValue.slice(0, 12);
    }
    setAccountId(enteredValue);
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
  };
  const handleAccess = (e) => {
    setShowAccessKey(e.target.value);
    setShowAkeyError(false);
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
  };
  const handleAssumeRole = (e) => {
    setShowAssumeKey(e.target.value);
    setShowAssumekeyError(false);
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
  };
  const handleAws = (e) => {
    setShowSecretKey(e.target.value);
    setShowsecretkeyError(false);
    setState((state) => ({
      ...state,
      conformationPop: true,
    }));
  };
  const businessSave = useCallback(async () => {
    if (currentAction === "edit") {
      handleSaveEdit();
    } else {
      handleSaveAdd();
    }
  });
  const addserverclose = async () => {
    dispatch(hideOffCanvas(false));
    setIsSidebarOpen(false);
    resetInput();
    addBodyCloseAccount();
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
  };
 const testConnection = () => {
  let payload;
  
  if (selectedOption === "AssumeRole") {
    payload = {
      accountType: selectedOption,
      assumeRole: showAssumeKey,
      accountId: accountId,
    };
  } else { // AccessCredentials
    payload = {
      accountType: selectedOption,
      accessKey: showAccessKey,
      secretKey: showSecretKey,
      accountId: accountId,
    };
  }

  const toolValid = validation();
  if (!toolValid) {
    setTestLoader(true);
    dispatch(cloudAccountTestConnection(payload)).then((data) => {
      if (data.payload?.statusCodeValue == 200) {
        callAlert(data.payload.body, "success");
        setTestLoader(false);
      } else if (data.payload?.statusCodeValue == 400) {
        callAlert(data.payload.body, "error");
        setTestLoader(false);
      } else if (data.error) {
        callAlert("Something went wrong please try again.", "error");
        setTestLoader(false);
      }
    });
  }
};

  const callAlert = (message, type) => {
    callCommonAlert(type, message);
    hideCommonAlert();
  };
  const deleteId = () => {
  const payload = {
    id: [state.deleteId],
    csp: state.deleteCsp || "AWS"
  };

  setCloudDeleteLoading(true);
  getCloudDelete(payload)
    .unwrap()
    .then((data) => {
      setCloudDeleteLoading(false);
      
      // More robust status code handling
      if (data.statusCodeValue === 202 || data.statusCodeValue === 200) {
        setState((state) => ({
          ...state,
          modalOpen: false,
          tableReload: true,
        }));
        callAlert(data.body, "success");
        setpageNo(0);
        const searchPayload = getPayload(searchKey);
        fetchData(pageNo, pageLimit, searchPayload);
      } else if (data.statusCodeValue === 400) {
        setState((state) => ({
          ...state,
          modalOpen: false,
        }));
        callAlert(data.body, "error");
      } else if (data.statusCodeValue === 404) {
        callAlert("Cloud account not found", "error");
        setState((state) => ({ ...state, modalOpen: false }));
      } else {
        callAlert("Delete operation failed", "error");
        setState((state) => ({ ...state, modalOpen: false }));
      }
    })
    .catch((error) => {
      setCloudDeleteLoading(false);
      callAlert("Failed to delete cloud account", "error");
      setState((state) => ({ ...state, modalOpen: false }));
    });
};

  const handleShowManage = () => {
    setState({
      ...state,
      modalBodyTrigger: true,
    });
  };

  const modalBody = () => (
    <>
      <h4 className="delete-h">Delete Cloud Account</h4>
      {cloudDeleteLoading ? <Spinners /> : (<div>
        <p>
          Are you sure you would like to delete the Cloud Account Configuration?
        </p>
        <div className="btnswrap btn-dlt">
          <ButtonComponent
            text="Cancel"
            className={"cancelBtnStyle gray btn"}
            onClick={handleClose}
          />
          <ButtonComponent
            text="Delete"
            className={"btnStyle btn btn-primary"}
            onClick={deleteId}
          />
        </div>
      </div>)}
    </>
  );

  const handleClose = () => {
    setState({
      ...state,
      modalOpen: false,
    });
    hideCommonAlert();
  };
  const handleTriggerClose = () => {
    setState({
      ...state,
      modalBodyTrigger: false,
    });
  };
  const addmodalCancelAccount = () => {
    setState((state) => ({
      ...state,
      addBodyAccount: true,
    }));
  };
  const addBodyCloseAccount = () => {
    setState({
      ...state,
      addBodyAccount: false,
    });
  };
  const addBodyCancelAccount = () => {
    return (
      <>
        <DiscardChanges title={'add'} discardClick={addserverclose} cancelClick={addBodyCloseAccount} />
      </>
    );
  };



  const resetInput = () => {
    setShowAccessKey("");
    setAccountId("");
    setShowSecretKey("");
    setShowCsp("");
    setGetId("");
    setSelectedOption("AssumeRole");
  };

  let optData = state.appList.map((app) => ({ label: app.value }));
  const clickbtn = () => {
    setState((state) => ({
      ...state,
      conformationPop: false
    }));
    return openserver("add", 0);
  };


  const handleclickImport = () => {
    setState((state) => ({
      ...state,
      setImportOpen: true,
      file: '',
      fileInfo: '',
      fileError: '',
    }));
  };

  const btnData = [
    {
      text: "Add",
      function: clickbtn,
      className: !userAccess ? " accessDisabled" : "solid-btn",
      disabled: !userAccess,
    },
    {
      text: "Trigger Scan",
      function: userAccess && handleShowManage,
      className: !userAccess ? " accessDisabled" : "solid-btn",
      disabled: !userAccess,
    },
    {
      text: "Import CSV",
      function: handleclickImport,
      className: !userAccess ? " accessDisabled" : "solid-btn",
      disabled: !userAccess,
    },
  ];

  const modalBodyTrigger = () => (
    <>
      <h4 className="delete-h">Trigger Cloud Account</h4>
      {state.loading ? (
        <Spinners />
      ) : (
        <>
          <p>
            Are you sure you want to trigger the scan for the Cloud Account? Please
            ensure the provided Access Key and Security Key are correct, as this
            action will impact the Cloud Account configuration.
          </p>
          <div className="btnswrap btn-dlt cloudpadding">
            <ButtonComponent
              text="Cancel"
              className="cancelBtnStyle gray btn"
              data-testid="cancel-trigger-btn"
              onClick={handleTriggerClose}
            />
            <ButtonComponent
              text="Trigger"
              className="btnStyle btn btn-primary"
              data-testid="confirm-trigger-btn"
              onClick={handleTrigger}
            // isLoading={state.loading} // Uncomment this if needed
            />
          </div>
        </>
      )}
    </>
  );
  function getLimit(limit) {
    setpageLimit(limit);
    setpageNo(0);
    const payload = getPayload(searchKey);
    fetchData(0, limit, payload);

  }
  function getPage(pageNo) {
    setpageNo(pageNo);
    const payload = getPayload(searchKey);
    fetchData(pageNo, pageLimit, payload);
  }
  function getSearchKey(key) {
    setpageNo(0);
    setpageLimit(10);
    setsearchKey(key);
    const payload = getPayload(key);
    fetchData(0, 10, payload);
  }

  const importModalClose = () => {
    setState((state) => ({
      ...state,
      setImportOpen: false,
      fileError: "",
    }));
  };
  const importModal = () => (
    <>
      <h4>Import Cloud Accounts</h4>
      <div className="errors">{state.fileError}</div>
      <form id="upload-file-form" className="hide-ele">
        <div className="col-lg-12 upload-file-model">
          <label
            className="btn btn-submit chaos-btn ml-0 upload_btn"
            htmlFor="upload-file-input"
          >
            <input
              id="upload-file-input"
              data-testid="upload-file-input"
              type="file"
              accept=".csv"
              name="file"
              className="hide-ele"
              onChange={(event) => {
                setState({
                  ...state,
                  file: event.target.files[0] ? event.target.files[0] : "",
                  fileInfo: event.target.files[0].name ? event.target.files[0].name : "",
                  fileError: "",
                });
              }}
            />
          </label>
          <span className="label label-default hide filepath" id="upload-file-info">
            {state.fileInfo !== ""
              ? "C:\\fakepath\\" + `${state.fileInfo ? state.fileInfo : 'users'}`
              : ""}
          </span>
          <div className="col-md-12 upload_file pl-0">
            <a>Cloud_Accounts.csv</a>
          </div>
        </div>
      </form>
      <div className="btnswrap">
        <ButtonComponent text="Cancel" onClick={importModalClose} className="cancelBtnStyle" data-testid="cancel-import-btn" />
        <ButtonComponent text="Submit" onClick={importModalClose} data-testid="submit-import-btn" />

      </div>
    </>
  );



  return (
    <>
      <ProjectContext.Provider value={{ state, setState }}>
        <CustomModal
          modalOpen={state.modalOpen}
          modalBody={modalBody}
          modalTitle={"Delete Configuration"}
          closeBtn={false}
          closeBtnFuc={handleClose}
        />
        <CustomModal
          modalOpen={state.modalBodyTrigger}
          modalBody={modalBodyTrigger}
          modalHide={handleTriggerClose}
          closeBtn={false}
          closeBtnFuc={handleTriggerClose}
        />
        <CustomModal
          modalOpen={state.setImportOpen}
          modalBody={importModal}
          modalHide={importModalClose}
          closeBtn={true}
          closeBtnFuc={importModalClose}
        />
        <CustomModal
          modalOpen={state.addBodyAccount}
          modalBody={addBodyCancelAccount}
          modalHide={addmodalCancelAccount}
          closeBtn={true}
          closeBtnFuc={addBodyCloseAccount}
        />
        <EmptyDrillDownOffCanvas />
        {/* <DrillDownOffCanvas
          customClass={"flowblock toolwrap custom_scroll"}
          subHeading={"Please enter the Details."}
        /> */}
      </ProjectContext.Provider>

      {/* <div className="btnwrap d-flex justify-content-between m-0 device-licensce">
        <ButtonComponent text="Back" style={{ visibility: "hidden" }} />

        <div className="d-flex justify-content-end">
          <div className="mr-5">
            
          </div>
        </div>
      </div> */}

      <div className="row">
        <div
          id="tableCol"
          style={{
            marginRight: showServerForm ? "75%" : "0",
            width: showServerForm ? "75%" : "100%",
          }}
        >
          <div className="grid-table tablecloudAccounts">
            {/* {cloudAccountCountLoading || cloudAccountListLoading ? (
              <Spinners />
            ) : ( */}
            <>
              <CompleteTableData
                numberOfColumnsToFix={4}
                isLoading={cloudAccountListLoading}
                data={TableContent}
                columns={columns}
                onPageLimitChange={getLimit}
                onPageNoChange={getPage}
                onSearch={getSearchKey}
                curentPageNumber={pageNo}
                pageLimit={pageLimit}
                searchKey={searchKey}
                totalPageCount={finalPageCount}
                listCount={cloudAccountListData?.totalCount ? cloudAccountListData?.totalCount : 0}
                btnData={btnData}
                moveSearchToEnd={true}
              />
            </>
            {/* )} */}
          </div>
        </div>
        {!isEmpty(currentAction) ? (
          <CustomOffCanvas className="custom-off-canvas">
            <h3 className="flowhead" id="updatehead" style={{ display: "block" }}>
              {currentAction === "edit"
                ? "Update Cloud Account"
                : "Add New Cloud Account"}{" "}
            </h3>
            {testLoader || ddLoader ? (
              <Spinners />
            ) : (
              <>
                <Row className="m-0">
                  <Col>
                    <Input
                      type="text"
                      label="Cloud Service Provider*"
                      name="fullName"
                      id="BusinessDepartment"
                      error={showCSPError}
                      errorMessage={cSperrorMessage}
                      list="serverlistdatalist"
                      placeholder="Enter  Cloud Service Provider"
                      data-testid="csp-input"
                      autoComplete={"off"}
                      onChange={handleCSP}
                      containerClassName={"frmgroup validate default-input"}
                      readOnly={currentAction === "edit" ? true : false}
                      value={showCsp}
                      maxLength="30"
                    />
                  </Col>
                  <Col>
                    <Input
                      type="text"
                      label="Account ID*"
                      name="accountId"
                      id="accountId"
                      error={showAccError}
                      errorMessage={AccerrorMessage}
                      list="serverlistdatalist"
                      placeholder="Enter Account ID"
                      data-testid="accountid-input"
                      autoComplete={"off"}
                      onChange={handleACC}
                      containerClassName={"frmgroup validate default-input"}
                      readOnly={currentAction === "edit" ? true : false}
                      value={accountId}
                    />
                  </Col>
                </Row>
                <Row className="m-0">
                  <Col>
                    <div>
                      <label className="radiobtn-cloudaccts">
                        <input
                          type="radio"
                          name="option"
                          value="AssumeRole"
                          data-testid="assume-role-radio"
                          checked={selectedOption === "AssumeRole" ? true : false}
                          disabled={selectedOption === "AssumeRole" && currentAction === "edit" ? true : false}
                          onChange={currentAction === "edit" ? null : handleOptionChange}
                        />
                        <span className="mx-1">Assume Role</span>
                      </label>
                      <label className="radiobtn-cloudaccts">
                        <input
                          type="radio"
                          name="option"
                          value="AccessCredentials"
                          checked={selectedOption === "AccessCredentials" ? true : false}
                          data-testid="access-credentials-radio"
                          disabled={selectedOption === "AccessCredentials" && currentAction === "edit" ? true : false}
                          onChange={currentAction === "edit" ? null : handleOptionChange}
                        />
                        <span className="mx-1">Access Credentials</span>
                      </label>
                    </div>
                  </Col>
                  <Col> </Col>
                </Row>
                <Row className="m-0">
                  {selectedOption === "AssumeRole" ? (
                    <>
                      <Col>
                        <Input
                          type="text"
                          label="Assume Role*"
                          name="Business Capability"
                          id="BusinessCapability"
                          error={showAssumekeyError}
                          errorMessage={assumekeyerrorMessage}
                          list="serverlistdatalist"
                          placeholder="Enter Assume Role"
                          data-testid="assume-role-input"
                          autoComplete="off"
                          onChange={handleAssumeRole}
                          containerClassName="frmgroup validate default-input"
                          value={showAssumeKey}
                          maxLength="120"
                        />
                      </Col>
                      <Col>{/* Empty column to occupy right half */}</Col>
                    </>
                  ) : (
                    <>
                      <Col>
                        <Input
                          type="text"
                          label="Access Key*"
                          name="Business Capability"
                          id="BusinessCapability"
                          error={showAkeyError}
                          errorMessage={AkeyerrorMessage}
                          list="serverlistdatalist"
                          placeholder="Enter Access Key"
                          data-testid="access-key-input"
                          autoComplete="off"
                          onChange={handleAccess}
                          containerClassName="frmgroup validate default-input"
                          value={showAccessKey}
                          maxLength="120"
                        /> 
                      </Col>
                      <Col>
                        <Input
                          type="text"
                          label="Secret Key*"
                          name="Business Capability"
                          id="BusinessCapability"
                          error={showsecretkeyError}
                          errorMessage={secretKeyerrorMessage}
                          list="serverlistdatalist"
                          placeholder="Enter Secret Key"
                          data-testid="secret-key-input"
                          autoComplete="off"
                          onChange={handleAws}
                          containerClassName="frmgroup validate default-input"
                          value={showSecretKey}
                          maxLength="40"
                        />
                      </Col>
                    </>
                  )}
                </Row>



                <Row className="m-0">
                  <Col></Col>
                  <Col>
                    <div className="server-btn">
                      <ButtonComponent text="Test Connection" className={"greenBtnStyle"} data-testid="test-connection-btn" onClick={() => { testConnection(); }} />

                      <ButtonComponent text="Cancel" className={"cancelBtnStyle"} data-testid="cancel-btn"  onClick={() => {
                        if (state.conformationPop) {
                          addmodalCancelAccount();
                        } else {
                          addserverclose();
                        }
                      }}
                      />

                      <ButtonComponent text="Save" data-testid="save-btn" onClick={() => { businessSave();}} />
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </CustomOffCanvas>
        ) : (null)}

      </div>
    </>
  );
};

export default Cloudaccount;